module.exports = __webpack_public_path__ + "72c38283e7444215fe49c71e532e324a.MP3";